import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { BackgroundColor } from '.';

export const Wrapper = styled.div`
  display: inline-block;
`;

export const Content = styled.div<{
  shouldWrapText?: boolean;
}>`
  padding: 0.5rem;
  font-size: 0.8rem;
  white-space: ${({ shouldWrapText = true }) =>
    shouldWrapText ? 'wrap' : 'nowrap'};
  border: 1px solid ${theme.color.border.divider};

  line-height: 1.3rem;
`;

export const Placeholder = styled.div`
  position: absolute;
  z-index: 999999999;
`;

export const RelativeWrapper = styled.div<{
  visible: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;

  &:after,
  &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    pointer-events: none;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
  }
  &::before {
    z-index: 1;
  }
`;

export const TooltipWrapper = styled.div<{
  visible: boolean;
  backgroundColor?: BackgroundColor;
}>`
  position: absolute;
  background-clip: content-box;
  background-color: ${({ backgroundColor }) =>
    theme.color.background[backgroundColor || 'primary']};

  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;
